// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
// Read the app-context flag before sign-in rewrites the URL.
import './utils/appContext';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
